import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import styles from './PredictiveSignals.module.css';
import SignalsSuite from './SignalsSuite';
import TextsVideosSuite from './TextsVideosSuite';

const options = [
  {
    key: 'signals-suite',
    icon: faChartLine,
    accent: 'accentTeal',
    name: 'Cross-Asset Signals',
    desc: 'Signals across entities and asset classes.',
  },
  {
    key: 'unstructured-insights',
    icon: faFileAlt,
    accent: 'accentIndigo',
    name: 'Alternative Insights',
    desc: 'Insights from alternative and unstructured data.',
  },
];

const PredictiveSignals = () => {
  const [active, setActive] = useState(null);
  const activeOption = options.find((item) => item.key === active);

  return (
    <div className={styles.page}>
      <div className={styles.breadcrumb}>
        <Link to="/" className={styles.breadcrumbLink}>Home</Link>
        <span className={styles.breadcrumbSep}>/</span>
        {activeOption ? (
          <button type="button" className={styles.breadcrumbLink} onClick={() => setActive(null)}>
            Predictive Signals
          </button>
        ) : (
          <span className={styles.breadcrumbCurrent}>Predictive Signals</span>
        )}
        {activeOption && (
          <>
            <span className={styles.breadcrumbSep}>/</span>
            <span className={styles.breadcrumbCurrent}>{activeOption.name}</span>
          </>
        )}
      </div>

      <div className={styles.panel}>
        {!activeOption ? (
          <>
            <p className={styles.eyebrow}>Predictive Signals</p>
            <h1 className={styles.headline}>Choose your signal source</h1>
            <p className={styles.subline}>
              Pick a path to start turning data into forward-looking signals.
            </p>

            <div className={styles.optionGrid}>
              {options.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  className={`${styles.optionCard} ${styles[item.accent]}`}
                  onClick={() => setActive(item.key)}
                >
                  <span className={styles.optionIcon}>
                    <FontAwesomeIcon icon={item.icon} />
                  </span>
                  <span className={styles.optionBody}>
                    <span className={styles.optionNameRow}>
                      <span className={styles.optionName}>{item.name}</span>
                      <span className={styles.optionArrow}>→</span>
                    </span>
                    <span className={styles.optionDesc}>{item.desc}</span>
                  </span>
                </button>
              ))}
            </div>
          </>
        ) : (
          <>
            <div className={styles.activeHeader}>
              <span className={styles.activeTitle}>{activeOption.name}</span>
              <div className={styles.tabStrip}>
                {options.map((item) => (
                  <button
                    key={item.key}
                    type="button"
                    title={item.desc}
                    className={`${styles.tab} ${styles[item.accent]} ${active === item.key ? styles.tabActive : ''}`}
                    onClick={() => setActive(item.key)}
                  >
                    <span className={styles.tabIcon}>
                      <FontAwesomeIcon icon={item.icon} />
                    </span>
                    {item.name}
                  </button>
                ))}
              </div>
            </div>

            <div className={styles.embedWrapper}>
              {active === 'signals-suite' && <SignalsSuite />}
              {active === 'unstructured-insights' && <TextsVideosSuite />}
            </div>
          </>
        )}
      </div>

      <Link to="/" className={styles.backLink}>Back</Link>
    </div>
  );
};

export default PredictiveSignals;
